import { render, staticRenderFns } from "./ClientActionDelete.vue?vue&type=template&id=ea71bc0a&"
import script from "./ClientActionDelete.vue?vue&type=script&lang=ts&"
export * from "./ClientActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports